import React, { useState } from "react";
import SolidButton from "../../common/buttons/SolidButton";
import "./style.css";
import AlternateButton from "../../common/buttons/AlternateButton";

const MobileNumberPopup = ({ CloseModal, IsOpen ,emiResult}) => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [isValid, setIsValid] = useState(true);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setMobileNumber(value);
    setIsValid(/^[0-9]{10}$/.test(value));
  };

  const handleClick = () => {
    if (isValid && mobileNumber.length === 10) {
      emiResult()
    } else {
      setIsValid(false); // Set isValid to false to show the error message
    }
  };

  return (
    IsOpen && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
        <div className="bg-[#F3F3F9] text-center shadow-lg absolute md:rounded-[1vw] rounded-[5vw]">
          <div className="md:w-[90%] w-[70%] m-auto pb-[2vw] md:py-[2vw] py-[4vw]">
            <button
              onClick={CloseModal}
              className="absolute top-1 right-4 md:text-[2vw] text-[7vw] font-[600] text-black hover:text-orange-500 transition"
            >
              &times;
            </button>

            <p className="md:text-[2.5vw] text-[6vw] font-krubMedium text-[#2E3192]">
              Unlock your financial insight
            </p>
            <p className="md:w-[60%] w-[70%] m-auto md:text-[1.3vw] text-[3vw] mt-[0.5vw] font-krubMedium text-[#333333]">
              Enter your mobile number to calculate your EMI
            </p>
          </div>
          <div className="bg-white w-[100%] md:rounded-b-[1vw] rounded-b-[5vw] px-[5vw] md:py-[2vw] py-[5vw] gap-x-[2vw] mt-[1vw]">
            <div className="md:flex flex-none justify-between items-center ">
              <div>
                <input
                  className={`mobile-number-input md:w-[18vw] w-[90%] md:h-[3vw] h-[5vw] md:px-[1vw] px-[2vw] md:py-0 py-[4vw] border-0 border-b-[1px] border-[#99999A] font-krubMedium md:text-[1.5vw] text-[4vw] outline-none bg-transparent`}
                  type="text"
                  name="mobile"
                  id="mobile"
                  placeholder="Mobile Number"
                  pattern="[0-9]{10}"
                  required
                  maxLength="10"
                  onChange={handleInputChange}
                  value={mobileNumber}
                />
              </div>
              <div onClick={handleClick} className="ml-[1vw] md:block hidden">
                <SolidButton
                  label={"Get Details"}
                  label_color={"#FFFFFF"}
                  background_color={"#F58220"}
                />
              </div>
              <div onClick={handleClick} className="mt-[4vw] md:hidden block">
                <AlternateButton
                  label={"Get Details"}
                  labelColor={"#FFFFFF"}
                  bgColor={"#F58220"}
                />
              </div>
            </div>
            {!isValid && (
              <p className="text-red-500 md:ml-0 ml-[1vw] font-krubMedium md:text-[0.9vw] text-[3vw] text-left md:mt-[0.2vw] mt-[1vw]">
                Please enter a valid 10-digit mobile number
              </p>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default MobileNumberPopup;
